module.exports = "../../static/img/errorData.253991a.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/errorData.png
// module id = 8vgG
// module chunks = 35